module.exports = {"Operate17":{"daobanList":[{"title":"1:劳务派遣经营许可（新设）","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、劳务派遣经营许可表格","state":"必要"},{"name":"2、劳动合同及劳务派遣协议书","state":"必要"},{"name":"3、验资报告或者财务审计报告","state":"必要"},{"name":"4、劳务派遣管理制度","state":"必要"},{"name":"5、经营场所的使用证明以及与开展业务相适应的办公设施设备、信息管理系统等清单；","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-17.json
// module id = 1274
// module chunks = 0